<template>
  <div class="h-full" v-loading="loading">
    <edit class="h-full" />
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getSurveyById } from '@/api/survey'
import Edit from '@/views/survey/edit/Edit'
import { createWj } from '@/api/wenjuan/wjquestion'
import { getFreeLink, openPublishWj, saveBrowserMaxAnswerNum } from '@/api/wenjuan/publish'
import { PostMessage } from '@dygc/shared'

export default {
  name: 'EditSurvey',
  components: { Edit },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (GlobalConfig.getSurveyId()) {
        this.initSurvey()
      } else {
        this.createSurvey()
      }
    },
    async createSurvey() {
      try {
        const {
          data: { data: survey }
        } = await createWj('请填写问卷调查标题', null)
        const surveyId = survey.id
        GlobalConfig.setSurveyId(surveyId)
        saveBrowserMaxAnswerNum(surveyId, { browserMaxAnswerNum: 0 })
        await openPublishWj(surveyId)
        let { data: channel } = await getFreeLink({ channelType: '0', surveyId })
        const msg = new PostMessage('*')
        msg.sendMessage('createSurvey', { surveyId, answerChannelId: channel?.data[0]?.id })
        this.initSurvey()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    initSurvey() {
      getSurveyById(GlobalConfig.getSurveyId()).then(res => {
        this.$store.dispatch('initSurvey', res.data.data)
      })
    }
  }
}
</script>
